<template>
  <div>
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CyclePerformanceGraphic',
    data() {
        return {
        }
    },
    computed:{
        ...mapGetters(['selectedCycle']),
        seriesData() {
            const data = [];
            
            // Desafio
            data.push({
                name: 'Desafio',
                y: Number(this.selectedCycle.performance ?? 0),
                color: '#e7827f',
                borderColor: '#e66f6a'
            });
            
            // Módulos
            this.selectedCycle.modules?.forEach((module) => {
                data.push({
                    name: `Módulo ${module.module_order}`,
                    y: Number(module.performance ?? 0),
                    color: '#292593',
                    borderColor: '#0601c0'
                });
            });
            
            return [{
                name: 'Notas',
                colorByPoint: true,
                data: data
            }];
        },
        chartOptions(){
            return {
                chart: {
                    type: 'column',
                    backgroundColor: 'transparent',
                    style: {
                        fontFamily: 'Inter, sans-serif'
                    }
                },
                title: {
                    text: null
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        style: {
                            fontFamily: 'Inter, sans-serif'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    title: {
                        text: 'Notas',
                        style: {
                            fontFamily: 'Inter, sans-serif'
                        }
                    },
                    gridLineWidth: 1,
                    gridLineColor: '#e0e0e0',
                    labels: {
                        format: '{value}%',
                        style: {
                            fontFamily: 'Inter, sans-serif'
                        }
                    }
                },
                legend: {
                    enabled: false,
                    itemStyle: {
                        fontFamily: 'Inter, sans-serif'
                    }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    useHTML: true,
                    headerFormat: '<div style="font-family: Inter, sans-serif; font-size:11px;">{series.name}</div>',
                    pointFormat: '<div style="font-family: Inter, sans-serif; color:{point.color};">{point.name}: <b>{point.y:.0f}%</b></div>',
                    footerFormat: '</div>',
                    backgroundColor: '#ffffff',
                    borderColor: '#cccccc',
                    borderRadius: 4,
                    shadow: true
                },
                plotOptions: {
                    series: {
                        borderWidth: 2,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:.0f}%',
                            inside: true,
                            verticalAlign: 'bottom',
                            backgroundColor: '#d3d3d3',
                            borderRadius: 0,
                            padding: 4,
                            style: {
                                color: '#000000',
                                fontFamily: 'Inter, sans-serif'
                            }
                        }
                    }
                },
                plotArea: {
                    backgroundColor: 'transparent'
                },
                series: this.seriesData
            };
        }
    },
    methods: {
        getSeriesData() {

            const seriesData = [];
            
            seriesData.push({
                name: 'Nota no desafio',
                data: this.selectedCycle.performance,
                color: '#f74a4b' // Pink
            });
            
            // Série para cada Módulo
            this.selectedCycle.modules.forEach((module, index) => {
                seriesData.push({
                    name: `Nota M${module.module_order}`,
                    data: module.performance ? [Number(module.performance + 10)] : [0+10],
                    color: '#0066ff' // Blue
                });
            });
            
            return seriesData;
        }
    }
}
</script>
